module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    attrs: {
      "id": "bg-video",
      "poster": "/static/tngscreen.jpg",
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/static/worf-screen.mp4",
      "type": "video/mp4"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5bf0cd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BgVideo.vue
// module id = 45
// module chunks = 0